import { storage, database } from "./../firebase.init";

const TOP = "/media";

export const listFiles = async (folder) => {
  return (await storage.ref(`${TOP}/${folder}`).listAll()).items;
};

export const listFilesPaginated = async (
  folder,
  maxResults = 100,
  nextPageToken = null
) => {
  const folderRef = storage.ref(`${TOP}/${folder}`);
  if (nextPageToken) {
    try {
      let nextPageResults = await folderRef.list({
        maxResults: maxResults,
        pageToken: nextPageToken,
      });
      return {
        nextPageToken: nextPageResults.nextPageToken,
        items: nextPageResults.items,
      };
    } catch (err) {
      // NextPageToken passed is invalid.
      // Return the first page.
      const firstPage = await folderRef.list({ maxResults: maxResults });
      return {
        items: firstPage.items,
        nextPageToken: firstPage.nextPageToken,
      };
    }
  }
  const firstPage = await folderRef.list({ maxResults: maxResults });
  return {
    items: firstPage.items,
    nextPageToken: firstPage.nextPageToken,
  };
};

const getUniqueId = async () => {
  return (await database.ref("/fileIds").push()).key;
};

export const deleteFile = async (folder, file) => {
  try {
    await storage.ref(`${TOP}/${folder}/${file}`).delete();
    return {
      status: "success",
      deletedFilePath: `${TOP}/${folder}/${file}`,
    };
  } catch (err) {
    // Maybe the file doesn't exist?
    return Promise.resolve({
      status: "failure",
      deletedFilePath: `${TOP}/${folder}/${file}`,
    });
  }
};

export const deleteFolder = async (folder) => {
  try {
    const allFiles = await listFiles(folder);
    if (allFiles?.length > 0) {
      await Promise.allSettled(
        allFiles.map((file) => {
          return deleteFile(folder, file.name);
        })
      );
      return {
        status: "success",
        deletedFolderPath: `${TOP}/${folder}`,
      };
    }
  } catch (err) {
    return Promise.resolve({
      status: "failure",
      deletedFolderPath: `${TOP}/${folder}`,
    });
  }
};

export const uploadFile = async (folder, file) => {
  try {
    const myUniqueId = await getUniqueId();
    const snapshot = await storage
      .ref(`${TOP}/${folder}/`)
      .child(`${myUniqueId}-${file.name}`)
      .put(file);
    return {
      fileName: `${myUniqueId}-${file.name}`,
      url: await snapshot.ref.getDownloadURL(),
    };
  } catch (err) {
    // Couldn't upload it.
    return Promise.resolve({
      fileName: "",
      url: "",
    });
  }
};

export const deleteStorage = async () => {
  const _deleteFolderContents = async (path) => {
    const ref = storage.ref(path);
    try {
      const dir = await ref.listAll();
      dir.items.forEach((fileRef) => {
        _deleteFile(ref.fullPath, fileRef.name);
      });
      dir.prefixes.forEach((folderRef) => {
        _deleteFolderContents(folderRef.fullPath);
      });
    } catch (err) {
      return false;
    }
  };
  const _deleteFile = (pathToFile, fileName) => {
    return storage.ref(pathToFile).child(fileName).delete();
  };

  return await _deleteFolderContents(TOP);
};
